/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Account from './Account';
import User from './User';

/**
 * The ResellerAccountCreatedResponse model module.
 * @module model/ResellerAccountCreatedResponse
 * @version V1
 */
class ResellerAccountCreatedResponse {
    /**
     * Constructs a new <code>ResellerAccountCreatedResponse</code>.
     * @alias module:model/ResellerAccountCreatedResponse
     */
    constructor() { 
        
        ResellerAccountCreatedResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ResellerAccountCreatedResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ResellerAccountCreatedResponse} obj Optional instance to populate.
     * @return {module:model/ResellerAccountCreatedResponse} The populated <code>ResellerAccountCreatedResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ResellerAccountCreatedResponse();

            if (data.hasOwnProperty('account')) {
                obj['account'] = Account.constructFromObject(data['account']);
            }
            if (data.hasOwnProperty('firstUser')) {
                obj['firstUser'] = User.constructFromObject(data['firstUser']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ResellerAccountCreatedResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ResellerAccountCreatedResponse</code>.
     */
    static validateJSON(data) {
        // validate the optional field `account`
        if (data['account']) { // data not null
          Account.validateJSON(data['account']);
        }
        // validate the optional field `firstUser`
        if (data['firstUser']) { // data not null
          User.validateJSON(data['firstUser']);
        }

        return true;
    }


}



/**
 * @member {module:model/Account} account
 */
ResellerAccountCreatedResponse.prototype['account'] = undefined;

/**
 * @member {module:model/User} firstUser
 */
ResellerAccountCreatedResponse.prototype['firstUser'] = undefined;






export default ResellerAccountCreatedResponse;

